import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'

import { FASTLY_PATH } from '~/const/asset'

const FileCellRenderer = ({ value }: ICellRendererParams<unknown, { file_id: string }>): ReactElement => {
  if (value) {
    return <img src={`${FASTLY_PATH}${value}`} />
  }

  return <div />
}

export default FileCellRenderer
